<template>
  <div :class="className">
    <label>{{ label }}</label>
    <!-- <textarea v-bind="$attrs" :value="value" v-on="listeners" v-validate="validate"
      :style="{ minHeight: `${minHeight}px` }"></textarea> -->
    <div :class="`html-editor-${uuid}`" :style="{ minHeight: `${minHeight}px` }"></div>
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
    <TypographyMeta v-if="meta" v-html="meta" />
    <TypographyInputError v-if="hasErrors">{{ errors.first($attrs.name) }}</TypographyInputError>
  </div>
</template>

<script>
  import BaseInput from './BaseInput'
  import CodeFlask from 'codeflask';
  import { generateUuid } from '@/helpers'

  export default {
    extends: BaseInput,
    props: {
      minHeight: { default: 250 }
    },

    data () {
      return {
        flask: null,
        uuid: generateUuid()
      }
    },

    methods: {
      handleCodeUpdate (code) {
        this.$emit('input', code)
      }
    },

    mounted () {
      this.flask = new CodeFlask(`.html-editor-${this.uuid}`, { language: 'html', lineNumbers: false, defaultTheme: false })
      if (this.value) {
        this.flask.updateCode(this.value)
      }
      this.flask.onUpdate(this.handleCodeUpdate)
    }
  }
</script>
<style lang="scss">
  @import './src/assets/styles/colors.scss';

  [class^="html-editor-"] {
    position: relative;

    .codeflask {

      textarea, pre {
        font-size: 13px !important;
        line-height: 19px !important;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace !important;
      }

      pre {
        border: 0;
        padding: 8px 13px;
        background: none !important;
      }

      textarea {
        top: 1px;
        left: 1px;
        width: calc(100% - 2px) !important;
        height: calc(100% - 2px);
        padding: 6px 11px; // important to match fake <pre> need to be here
        border: 1px solid $color-border-form-field;
        border-radius: 3px;

        &::selection {
          background: $color-text-selection;
          color: transparent;
        }        

        &::-moz-selection {
          background: $color-text-selection;
          color: transparent;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseHtml.vue